var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFavouriteBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 17.4355C9.72355 17.4355 9.45565 17.3998 9.23239 17.3195C5.82104 16.1496 0.400391 11.997 0.400391 5.86196C0.400391 2.73638 2.92765 0.200195 6.03537 0.200195C7.54458 0.200195 8.95555 0.789591 10.0004 1.84336C11.0452 0.789591 12.4562 0.200195 13.9654 0.200195C17.0731 0.200195 19.6004 2.74531 19.6004 5.86196C19.6004 12.006 14.1797 16.1496 10.7684 17.3195C10.5451 17.3998 10.2772 17.4355 10.0004 17.4355ZM6.03537 1.53973C3.66886 1.53973 1.73993 3.47759 1.73993 5.86196C1.73993 11.9613 7.60709 15.3548 9.66997 16.0603C9.83072 16.1139 10.179 16.1139 10.3397 16.0603C12.3937 15.3548 18.2698 11.9702 18.2698 5.86196C18.2698 3.47759 16.3409 1.53973 13.9743 1.53973C12.617 1.53973 11.3578 2.17378 10.5451 3.2722C10.2951 3.61154 9.72355 3.61154 9.47351 3.2722C8.643 2.16485 7.39276 1.53973 6.03537 1.53973Z",
    fill: "#5A5C61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFavouriteBlack);
export default __webpack_public_path__ + "static/media/not-favourite-black.eac71e16489390a102bc389020ae6ee0.svg";
export { ForwardRef as ReactComponent };